import { render } from "@testing-library/react";
import { Button, Popconfirm, Space } from "antd";
import { CiEdit } from "react-icons/ci";
import { FaRegTrashAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  ExclamationCircleTwoTone,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import translate from "../../../i18n/translate";
import { uz } from "date-fns/locale";
import { format } from "date-fns";

export const getColumns = () => {
  const noColumn = {
    title: translate("table.column.no"),
    dataIndex: "no",
    key: "no",
    width: 50,
  };

  return {
    user: [
      // noColumn,
      {
        title: translate("table.column.username"),
        dataIndex: "username",
        key: "username",
      },

      {
        title: translate("table.column.role"),
        dataIndex: "role",
        key: "role",
      },
      {
        title: translate("table.column.phone"),
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: translate("table.column.status"),
        dataIndex: "status",
        key: "status",
      },
    ],
    action: [
      // noColumn,
      {
        title: translate("table.column.username"),
        dataIndex: "user",
        key: "user",
        render: (user) => user && user.username,
      },

      {
        title: translate("table.column.action_type"),
        dataIndex: "actionType",
        key: "actionType",
      },
      {
        title: translate("table.column.target"),
        dataIndex: "targetType",
        key: "targetType",
      },
      {
        title: translate("table.column.timestamp"),
        dataIndex: "timestamp",
        key: "timestamp",
        render: (time) => format(time, "d MMMM yyyy, HH:mm:ss", { locale: uz }),
      },
    ],
  };
};

export const getActions = ({
  idName = "id",
  page,
  handleDelete,
  isEditable,
  isDeletable,
}) => ({
  title: translate("table.column.actions"),
  dataIndex: idName,
  key: "link",
  width: 100,
  fixed: "right",
  render(id, data) {
    return (
      <div>
        <Space>
          {page && isEditable && (
            <Link to={`/main/${page}/${id}`}>
              <Button>
                <CiEdit />
              </Button>
            </Link>
          )}

          {isDeletable && (
            <Popconfirm
              title={translate("common.delete")}
              description={translate("confirm.delete")}
              onConfirm={() => handleDelete(id, data)}
              okText={translate("common.yes")}
              cancelText={translate("common.no")}
              placement="topLeft"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            >
              <Button type="primary" danger>
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          )}
        </Space>
      </div>
    );
  },
});
